const KEY = 'DIY_RECENT_COLORS';
const MAX = 12;

export class RecentColorsLsManager {

    public static saveColor(color: string) {
        if (window.localStorage) {
            let recentColors = this.getRecentColors();

            if (recentColors === null) {
                recentColors = [];
            }

            const index = recentColors.indexOf(color);

            if (index !== -1) {
                recentColors.splice(index, 1);
            }

            recentColors.unshift(color);
            recentColors.splice(MAX);
            window.localStorage.setItem(KEY, JSON.stringify(recentColors));
        }
    }

    public static getRecentColors() {
        if (window.localStorage) {
            return JSON.parse(window.localStorage.getItem(KEY));
        }

        return null;
    }

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/color-picker/RecentColorsLsManager.ts
 **/